"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyDialog = void 0;

const faExclamationCircle_1 = require("@fortawesome/pro-regular-svg-icons/faExclamationCircle");

const faTimes_1 = require("@fortawesome/pro-regular-svg-icons/faTimes");

const react_fontawesome_1 = require("@fortawesome/react-fontawesome");

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importStar(require("react"));

const SskyButton_1 = __importDefault(require("../SskyButton"));

const SskyCircularProgress_1 = __importDefault(require("../SskyCircularProgress"));

const SskyIconButton_1 = __importDefault(require("../SskyIconButton"));

const SskyNonIntrusiveNotification_1 = __importDefault(require("../SskyNonIntrusiveNotification"));

const StyledDialogTitleContainer = (0, material_1.styled)("div", {
  shouldForwardProp: prop => prop !== "titleHeight"
})(({
  titleHeight
}) => ({
  display: "flex",
  alignItems: "center",
  height: titleHeight
}));
const StyledDialogTitleIconContainer = (0, material_1.styled)("div")({
  marginLeft: 24,
  marginTop: 4
});
const StyledCloseButton = (0, material_1.styled)(SskyIconButton_1.default)({
  marginLeft: "auto"
});
const StyledCloseButtonIcon = (0, material_1.styled)(react_fontawesome_1.FontAwesomeIcon)({
  color: "#757575"
});
const StyledSpinnerContainer = (0, material_1.styled)("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
});
const StyledSskyNonIntrusiveNotification = (0, material_1.styled)(SskyNonIntrusiveNotification_1.default)({
  fontFamily: "Roboto"
});
const StyledDialogContent = (0, material_1.styled)(material_1.DialogContent, {
  shouldForwardProp: prop => prop !== "contentMaxHeight" && prop !== "disabled"
})(({
  contentMaxHeight,
  disabled
}) => ({
  [`&.${material_1.dialogContentClasses.root}`]: Object.assign({
    maxHeight: contentMaxHeight || "none",
    padding: 24
  }, disabled && {
    pointerEvents: "none",
    opacity: 0.5
  })
}));
const StyledDialogContentText = (0, material_1.styled)(material_1.DialogContentText)({
  [`&.${material_1.dialogContentTextClasses.root}`]: {
    color: "#333333",
    fontSize: 16,
    whiteSpace: "pre-line"
  }
});
const StyledExclamationIcon = (0, material_1.styled)(react_fontawesome_1.FontAwesomeIcon, {
  shouldForwardProp: prop => prop !== "promptType"
})(({
  promptType
}) => ({
  fontSize: 17,
  marginRight: 10,
  verticalAlign: "top",
  marginTop: 3,
  color: promptType === "info" ? "#2D9CDB" : promptType === "warning" ? "#FF9900" : promptType === "error" ? "#ff3333" : undefined
}));
const StyledDialogActions = (0, material_1.styled)(material_1.DialogActions)({
  [`&.${material_1.dialogActionsClasses.root}`]: {
    margin: 0,
    padding: "10px 24px"
  }
});
const StyledSskyButton = (0, material_1.styled)(SskyButton_1.default)({
  margin: "0 0 0 10px",
  minWidth: 90
});

const SskyDialog = props => {
  const renderTitle = () => {
    return react_1.default.createElement(StyledDialogTitleContainer, null, props.icon && react_1.default.createElement(StyledDialogTitleIconContainer, null, props.icon), react_1.default.createElement(material_1.DialogTitle, {
      id: "form-dialog-title"
    }, props.title), props.showCloseButton && react_1.default.createElement(StyledCloseButton, {
      icon: react_1.default.createElement(StyledCloseButtonIcon, {
        icon: faTimes_1.faTimes
      }),
      onClick: props.onClose,
      dataTestId: props.closeButtonDataTestId || `testId-closeButtonDataTestId-${props.id}`,
      dataTrackingId: props.closeButtonDataTrackingId || `tracking-id-closeButtonDataTrackingId-${props.id}`
    }));
  };

  return react_1.default.createElement(material_1.Dialog, {
    id: props.id,
    className: (0, classnames_1.default)("SskyDialog", props.className),
    open: props.open,
    fullWidth: props.fullWidth,
    fullScreen: props.fullScreen,
    maxWidth: props.maxWidth,
    onClose: props.onClose,
    disableEscapeKeyDown: props.disableEscapeKeyDown || props.disabled,
    disableEnforceFocus: props.disableEnforceFocus,
    "aria-labelledby": "form-dialog-title",
    "aria-describedby": "form-content-text",
    "data-testid": props.dataTestId || `testId-dialog-${props.id || props.title}`,
    "data-tracking-id": props.dataTrackingId || `tracking-id-dialog-${props.id || props.title}`,
    onClick: props.onClick
  }, props.disabled && react_1.default.createElement(StyledSpinnerContainer, {
    "data-testid": "testId-dialog-circular-progress"
  }, react_1.default.createElement(SskyCircularProgress_1.default, null)), props.title && react_1.default.createElement(react_1.Fragment, null, renderTitle(), react_1.default.createElement(material_1.Divider, null)), props.notificationMessage && react_1.default.createElement(StyledSskyNonIntrusiveNotification, {
    notificationType: props.notificationType,
    text: props.notificationMessage
  }), react_1.default.createElement(StyledDialogContent, {
    className: props.contentClassName || "dialog-content",
    contentMaxHeight: props.contentMaxHeight,
    disabled: props.disabled
  }, props.contentText && react_1.default.createElement(StyledDialogContentText, {
    id: "form-content-text"
  }, props.promptType && react_1.default.createElement(StyledExclamationIcon, {
    icon: faExclamationCircle_1.faExclamationCircle,
    promptType: props.promptType
  }), props.contentText), props.children), (props.onCancelClick || props.onNegativeClick || props.onPositiveClick) && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(StyledDialogActions, null, props.footerChildren, props.onCancelClick && react_1.default.createElement(StyledSskyButton, {
    label: "Cancel",
    variant: "outlined",
    color: "secondary",
    onClick: props.onCancelClick,
    dataTestId: props.cancelButtonDataTestId || `testId-${props.id}-cancelButtonDataTestId`,
    dataTrackingId: props.cancelButtonDataTrackingId || `tracking-id-cancelButtonDataTrackingId`
  }), props.onNegativeClick && react_1.default.createElement(StyledSskyButton, {
    label: props.negativeButtonText || "",
    variant: "outlined",
    color: "secondary",
    onClick: props.onNegativeClick,
    dataTestId: props.negativeButtonDataTestId || `testId-${props.id}-negativeButtonDataTestId`,
    dataTrackingId: props.negativeButtonDataTrackingId || `tracking-id-negativeButtonDataTrackingId`
  }), props.onSecondPositiveClick && react_1.default.createElement(StyledSskyButton, {
    label: props.secondPositiveButtonText || "",
    onClick: props.onSecondPositiveClick,
    disabled: props.isValid === false || props.disabled,
    dataTestId: props.secondPositiveButtonDataTestId || `testId-${props.id}-secondPositiveButtonDataTestId`,
    dataTrackingId: props.secondPositiveButtonDataTrackingId || `tracking-id-secondPositiveButtonDataTrackingId`
  }), props.onPositiveClick && react_1.default.createElement(StyledSskyButton, {
    label: props.positiveButtonText || "",
    onClick: props.onPositiveClick,
    disabled: props.isValid === false || props.disabled,
    autoFocus: !props.disableEscapeKeyDown,
    dataTestId: props.positiveButtonDataTestId || `testId-${props.id}-positiveButtonDataTestId`,
    dataTrackingId: props.positiveButtonDataTrackingId || `tracking-id-positiveButtonDataTrackingId`,
    tooltip: props.positiveButtonTooltip,
    tooltipEnterDelay: props.tooltipEnterDelay,
    tooltipPlacement: props.tooltipPlacement
  }))));
};

exports.SskyDialog = SskyDialog;
SskyDialog.defaultProps = {
  disableBackdropClick: true,
  fullWidth: false,
  maxWidth: "lg",
  negativeButtonText: "Cancel",
  positiveButtonText: "OK",
  secondPositiveButtonText: "OK"
};
exports.default = react_1.default.memo(SskyDialog);